/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServiceProviderCategoryEnum } from './serviceProviderCategoryEnum';
import { TenantCreateRequestDto } from './tenantCreateRequestDto';
import { UserCreateRequestDto } from './userCreateRequestDto';

export interface CreateUserTenantRequestDto { 
    userCreateRequest?: UserCreateRequestDto;
    tenantCreateRequest?: TenantCreateRequestDto;
    spCategoryEnum?: ServiceProviderCategoryEnum;
    confirmationUrl?: string;
    targetUrl?: string;
}